import React, { useState } from "react";
import { Select } from "antd";

const FloatSelect = (props) => {
	const {
		id,
		value,
		label,
		placeholder,
		required,
		options = [],
		multi,
		popupClassName,
		size = "middle",
		className,
		...rest
	} = props;

	const [focus, setFocus] = useState(false);

	let new_placeholder = placeholder ? placeholder : label;

	let isOccupied = focus || (value && value.length !== 0);

	let labelClass = isOccupied ? "label float-label" : "label";

	let multiClass = multi ? "float-select-multi" : "float-select";

	let requiredMark = required ? <span className="text-danger">*</span> : null;

	return (
		<div
			id={id ?? ""}
			className={`float-wrapper ${className ?? ""} ${multiClass}`}
			onBlur={() => setFocus(false)}
			onFocus={() => setFocus(true)}
		>
			<Select
				value={value}
				style={{ width: "100%" }}
				size={size}
				showSearch
				mode={multi}
				popupClassName={`float-select-dropdown ${popupClassName ?? ""}`}
				filterOption={(input, option) => {
					// console.log("option", option);
					return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
				}}
				options={options}
				{...rest}
			/>
			<label className={labelClass}>
				{isOccupied ? label : new_placeholder} {requiredMark}
			</label>
		</div>
	);
};

export default FloatSelect;
